export const FINDING_PLACE_MAP: Record<string, string> = {
    '10': 'globalFindingPlaceSalesOrderNumber',
    '15': 'globalFindingPlaceRelatedToFoundOrders',
    '20': 'globalFindingPlaceDeliveryNumber',
    '30': 'globalFindingPlaceInvoiceNumber',
    '40': 'globalFindingPlaceMaterialNumber',
    '45': 'globalFindingPlaceCustMaterialNumber',
    '50': 'globalFindingPlaceBatchNumber',
    '60': 'globalFindingPlaceCustomerPurchaseOrder',
    '70': 'globalFindingPlaceSalesOrderDocument',
    '80': 'globalFindingPlaceDeliveryDocument',
    '90': 'globalFindingPlaceInvoiceDocument',
    '95': 'globalFindingPlaceTMDocument'
};

export const DOCUMENT_ORDER_SEARCH_INPUT_LOWER_LIMIT = 5;

export const DOCUMENT_ORDER_PAGE_SIZE_OPTIONS = [10, 20, 30];

export const DOCUMENT_TABLE_PAGE_SIZE_OPTIONS = 5;
